<h1>Contacto</h1>

<p>
<a href="http://hulat.inf.uc3m.es/nosotros/miembros/lmoreno">Lourdes Moreno</a> (<a href="mailto:lmoreno@inf.uc3m">lmoreno@inf.uc3m</a>)
</p>
<h2>Equipo:</h2>
<ul>
    <li>Investigadora Principal: Lourdes Moreno</li>
    <li>Equipo Investigador: Rodrigo Alarcón, Paloma Martínez, Isabel Segura-Bedmar</li>
    <li>Tecnicos de apoyo a la investigación: Jesus Galán Llano, Elena González Sabín</li>
</ul>
<p>
<a href="http://hulat.inf.uc3m.es/">Grupo Human Language and Accessibility Technologies (HULAT)</a>
</p>
<p>
Departamento de Informática
</p>
<p>
Universidad Carlos III de Madrid
</p>

<img src="../../../assets/hulat.png" alt="HULAT" class="center">